module.exports = __webpack_public_path__ + "static/media/Productivity.6e335abf.png";